import { render } from "./NotFound.vue?vue&type=template&id=55f78eab&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=55f78eab&scoped=true&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f78eab"]])

export default __exports__